export const LogEvents = {
    PARTICIPANT_CREATION_SUCCESS: 'lumos_participant_creation_success',
    PARTICIPANT_CREATION_ERROR: 'lumos_participant_creation_error',
    TRAINING_CERTIFICATE_WITH_NULL_COMPLETED_ON: 'lumos_training_certificate_with_null_completed_on',
    PARTICIPANT_RESPONSES_FETCHED: 'lumos_participant_responses_fetched',
    PARTICIPANT_RESPONSES_TAB_LOADED: 'lumos_participant_responses_tab_loaded',
    PI_OVERSIGHT_REVIEW_BUNDLE_FETCH_FAILED: 'lumos_pi_oversight_review_bundle_fetch_failed',
    PI_OVERSIGHT_SUMMARY_FETCH_FAILED: 'lumos_pi_oversight_summary_fetch_failed',
    PI_OVERSIGHT_SUMMARY_FETCH_FAILED_IN_CHINA_ENV: 'lumos_pi_oversight_summary_fetch_failed_in_china_env',
    PI_OVERSIGHT_VISIT_SCHEDULE_FETCH_FAILED: 'lumos_pi_oversight_visit_schedule_fetch_failed',
    PI_OVERSIGHT_SIGN_OFF_FAILED: 'lumos_pi_oversight_sign_off_failed',
    PI_OVERSIGHT_SIGN_OFF_SUCCESS: 'lumos_pi_oversight_sign_off_success',
};
